module.exports = __webpack_public_path__ + "static/img/immediate-use.275d3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/immediate-use.png
// module id = j0yL
// module chunks = 0